// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"b8f051cb","267":"cc65965b","472":"c9d90390","605":"ebe72656","709":"67d34edd","896":"7f3b41e6"}[chunkId] + ".chunk.css";
};